import { render } from "./notifications-settings.vue?vue&type=template&id=b246b91c"
import script from "./notifications-settings.vue?vue&type=script&lang=js"
export * from "./notifications-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__